import { memo, useMemo } from 'react';
import { formatMoney } from '../../guestCart/utils/money';

const LineRow = memo(function LineRow({ name, qty, total }) {
  return (
    <div className="ch-sum__line">
      <span className="ch-sum__line-left">
        <span className="ch-sum__line-qty">{qty} ×</span>
        <span className="ch-sum__line-name">{name}</span>
      </span>
      <span className="ch-sum__line-price">{formatMoney(total)}</span>
    </div>
  );
});

export default function OrderSummaryAside({
  restaurantName,
  lines = [],
  getLinePricing,
  totals,
  tipAmount = 0,
  showTipRow = true,
  orderType = 'delivery',
  className = '',
}) {
  const rows = useMemo(
    () =>
      lines.map((line) => ({
        key: line.lineId,
        name: line?.name || 'Item',
        qty: Math.max(1, Number(line?.qty || 1)),
        total: getLinePricing(line).total,
      })),
    [lines, getLinePricing]
  );

  const head = restaurantName ? `YOUR ORDER FROM ${String(restaurantName).toUpperCase()}` : 'YOUR ORDER';

  return (
    <aside className={`ch-sum ${className}`.trim()}>
      <div className="ch-sum__title">{head}</div>
      <div className="ch-sum__lines">
        {rows.map((r) => (
          <LineRow key={r.key} name={r.name} qty={r.qty} total={r.total} />
        ))}
      </div>
      <div className="ch-sum__break">
        <div className="ch-sum__row">
          <span>Subtotal</span>
          <span>{formatMoney(totals.subtotal)}</span>
        </div>
        {totals.discount > 0 ? (
          <div className="ch-sum__row ch-sum__row--muted">
            <span>Discount</span>
            <span>− {formatMoney(totals.discount)}</span>
          </div>
        ) : null}
        {orderType === 'delivery' ? (
          <div className="ch-sum__row ch-sum__row--muted">
            <span>Delivery fee</span>
            <span>{formatMoney(totals.delivery)}</span>
          </div>
        ) : null}
        <div className="ch-sum__row ch-sum__row--muted">
          <span>Fees &amp; estimated tax</span>
          <span>{formatMoney(totals.tax)}</span>
        </div>
        {showTipRow && tipAmount > 0 ? (
          <div className="ch-sum__row ch-sum__row--muted">
            <span>Tip (rider)</span>
            <span>{formatMoney(tipAmount)}</span>
          </div>
        ) : null}
      </div>
      <div className="ch-sum__total">
        <span>Total</span>
        <span>{formatMoney(totals.total + (showTipRow ? tipAmount : 0))}</span>
      </div>
    </aside>
  );
}
